import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.formatUtils;

export const formatDollars = (dollars, defaultString?): string => getRoot().formatDollars(dollars, defaultString);
export const formatDollarsAndCents = (dollars, defaultString?): string => getRoot().formatDollarsAndCents(dollars, defaultString);
